<app-container-popover
  *ngIf="showPopover"
  [parentRef]="elRef"
  popoverClass="popover-tour"
>
  <div class="popover-content d-flex flex-column">
    <p *ngIf="title" class="p4-semibold gmb-8 text-white">
      {{ title }}
    </p>
    <p class="p4-regular gmb-0 text-white">
      {{ text }}
    </p>
    <div class="align-items-center d-flex gmt-8 gmt-md-16">
      <p
        *ngIf="step !== totalSteps"
        class="p4-semibold text-white pointer gmb-0"
        (click)="skip()"
      >
        {{ 'WALKTROUGH.SKIP' | translate }}
      </p>
      <p
        *ngIf="totalSteps > 1"
        class="p4-regular gmb-0 gmr-8 ms-auto text-white"
      >
        {{ 'WALKTROUGH.STEP' | translate }} {{ step }}/{{ totalSteps }}
      </p>
      <button
        class="popover-button gbtn-bg gbtn-1 gbtn-sm b3-semibold"
        [class.ms-auto]="totalSteps <= 1"
        (click)="next()"
      >
        {{
          (step === totalSteps ? 'WALKTROUGH.GOT_IT' : 'WALKTROUGH.NEXT')
            | translate
        }}
      </button>
    </div>
  </div>
</app-container-popover>
